import { StarFilled, StarTwoTone } from '@ant-design/icons';
import { Card, Col, Empty, Input, message, Modal, Pagination, Row } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Loading } from '../../components/Loading';
import { TreeSelectLocationUser } from '../../components/TreeSelectLocation';
import { TreeSelectTopic } from '../../components/TreeSelectTopic';
import Api, { Api_v2, exceptionNotificationAPI } from '../../services/api';
import { parseFormListToTable } from './helper';

const { confirm } = Modal;

const Forms = ({ setStoreFilters, user }) => {
    const [filterRequest, setFilterRequest] = useState({
        pageNumber: 1,
        pageSize: 10,
        searchText: '',
        topicId: null,
    });
    const [locationId, setLocationId] = useState(null);
    const [paginationConfig, setPaginationConfig] = useState({ current: 1, total: 0 });
    const [listData, setListData] = useState([]);
    const [loading, setLoading] = useState(false);

    const getFormListData = useCallback(() => {
        setLoading(true);

        const locations = locationId ? [locationId] : [user?.locationId];
        const requestPayload = {
            ...filterRequest,
            locationIds: locations,
        };

        Api_v2.Form.getAdhocs(locations, requestPayload)
            .then(response => {
                const data = response.data;
                if (data && data.response) {
                    const parsed = parseFormListToTable(data);
                    setListData(parsed);
                    setPaginationConfig({
                        current: filterRequest.pageNumber,
                        total: data.response.rowCount,
                    });
                }
            })
            .catch(error => {
                exceptionNotificationAPI(error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [filterRequest, locationId]);

    useEffect(() => {
        getFormListData();
    }, [getFormListData]);

    const handleFavoriteForm = item => {
        confirm({
            title: item.bookmark ? 'Remover favorito?' : 'Adicionar aos favoritos?',
            content: `Formulário: ${item.title}`,
            okText: 'Sim',
            cancelText: 'Não',
            onOk: async () => {
                try {
                    await Api.post(`/Form/favorite?formId=${item.id}`);
                    message.success('Alteração salva com sucesso');
                    getFormListData();
                } catch (err) {
                    message.error('Erro ao favoritar');
                }
            },
        });
    };

    const onSearchText = value => {
        setFilterRequest(prev => ({ ...prev, pageNumber: 1, searchText: value }));
    };

    const onTopicChange = value => {
        setFilterRequest(prev => ({ ...prev, pageNumber: 1, topicId: value }));
    };

    const onLocationChange = value => {
        setLocationId(value);
        setFilterRequest(prev => ({ ...prev, pageNumber: 1 }));
    };

    const onPageChange = page => {
        setPaginationConfig(prev => ({ ...prev, current: page }));
        setFilterRequest(prev => ({ ...prev, pageNumber: page }));
    };

    return (
        <div>
            <Row gutter={16} style={{ marginBottom: 20 }}>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Input.Search
                        placeholder="Buscar por nome"
                        onSearch={onSearchText}
                        allowClear
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <TreeSelectLocationUser
                        placeholder="Localização"
                        onChange={onLocationChange}
                        style={{ width: '100%' }}
                    />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <TreeSelectTopic
                        placeholder="Tópico"
                        value={filterRequest.topicId}
                        onChange={onTopicChange}
                        style={{ width: '100%' }}
                    />
                </Col>
            </Row>

            {loading ? (
                <Loading />
            ) : listData.length === 0 ? (
                <Empty description="Nenhum formulário encontrado" />
            ) : (
                <>
                    {listData.map((item, index) => (
                        <Card key={item.id} className={index == 0 ? "card-p-10" : "mt-10 card-p-10"}>
                            <Row>
                                <Col span={23}>
                                    <Link
                                        onClick={setStoreFilters}
                                        to={{
                                            pathname: `/formbuilder/apply/${item.id}`,
                                            state: { redirectURL: "/home" }
                                        }}
                                        key={item.id}
                                        title={"Click to answer form - " + item.title}
                                    >
                                        <Row>
                                            <Col className="hidden-text-overflow" xl={21} lg={21}>
                                                <span style={{ color: "#000" }}>{item.title}</span>
                                            </Col>
                                            <Col xl={3} lg={3}>
                                                <small style={{ color: "#000" }}>{item.created_at}</small>
                                            </Col>
                                        </Row>
                                    </Link>
                                </Col>
                                <Col span={1}>
                                    {item.bookmark && (<StarFilled style={{ fontSize: 16, color: "#f9d71c" }} onClick={() => handleFavoriteForm(item)} title="Unfavorite" twoToneColor="#f9d71c" />)}
                                    {!item.bookmark && (<StarTwoTone style={{ fontSize: 16 }} onClick={() => handleFavoriteForm(item)} title="Favorite" twoToneColor="#f9d71c" />)}
                                </Col>
                            </Row>
                        </Card>
                    ))}

                    <Row justify="end" style={{ padding: 10 }}>
                        <Pagination
                            current={paginationConfig.current}
                            total={paginationConfig.total}
                            pageSize={filterRequest.pageSize}
                            showSizeChanger={false}
                            onChange={onPageChange}
                        />
                    </Row>
                </>
            )}
        </div>
    );
};

export default Forms;
